import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { AxleReportingContainerComponent } from 'src/app/features/reporting/container/axle-reporting-container.component';
import { CopilotPanelStore } from 'src/app/shared/services/chat/copilot-panel.state';
import { MeetingsStore } from 'src/app/shared/services/meetings/state/meetings.state';
import { ReportingStore } from 'src/app/shared/services/reporting/reporting.state';

export const clearMeetingsStore: CanDeactivateFn<
  AxleReportingContainerComponent
> = () => {
  const meetingsStore = inject(MeetingsStore);
  meetingsStore.reset();
  return true;
};

export const closeChatOnLeave: CanDeactivateFn<
  AxleReportingContainerComponent
> = () => {
  const reportingStore = inject(ReportingStore);
  const copilotPanelStore = inject(CopilotPanelStore);
  reportingStore.closeChat();
  copilotPanelStore.clearSelectedTableMessage();
  return true;
};
